// @flow

import { call, delay, put, race, take, takeLatest } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import { throttlingFailed, throttlingLoaded } from './actions';

const THROTTLING_REFRESH_INTERVAL = 5 * 60 * 1000;

function* loadThrottle({ payload: { domainId } }) {
    while (true) {
        try {
            const snapshot = yield call(fetchJSON, `/domains/${domainId}/throttling`, { method: 'GET' });
            yield put(throttlingLoaded(domainId, snapshot));
        } catch (error) {
            yield put(throttlingFailed(domainId, error));
            return;
        }

        const result = yield race({
            tick: delay(THROTTLING_REFRESH_INTERVAL),
            stop: take('THROTTLING_STOP'),
        });
        if (result.stop) return;
    }
}

export default function* ThrottlingSaga() {
    yield takeLatest('THROTTLING_LOAD', loadThrottle);
}
